export const COMMANDS_API_URL = 'ui/organization/commands';
